export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-exchange-5a286c0e68a326d0aabbdce04c07ada7.png";